// extracted by mini-css-extract-plugin
export default {"icon":"ContentButton-module-a3697667d44b6075846c"};